// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"JW-z","trustedRetailerTooltipWrapper":"KW-z"};